// Columna "Nivel AI" de Resultados: muestra la última corrida del servicio de
// IA (`ai_classification` del reply, que el backend sólo manda a staff). La
// mayoría de las encuestas nunca se clasificó, así que la celda queda vacía;
// los estados que no son un nivel se marcan con un símbolo corto y el detalle
// va en el tooltip.
export function aiLevelText(classification) {
    if (!classification) return '';
    if (classification.status === 'P') return '…';
    if (classification.status === 'E') return '!';
    if (classification.level == null) return '—';  // empate entre modelos
    return `${classification.level}${classification.sublevel || ''}`;
}

// Para el CSV/XLSX se exporta sólo el nivel: los estados intermedios (una
// corrida pendiente o fallida) son transitorios y no son un dato del empleado,
// así que la celda del archivo queda vacía igual que cuando nunca se clasificó.
export function aiLevelDownloadText(classification) {
    if (!classification || classification.status !== 'O' || classification.level == null) return '';
    return `${classification.level}${classification.sublevel || ''}`;
}

export function aiLevelTooltip(classification, tr) {
    if (!classification) return '';
    if (classification.status === 'P') return tr('ai_classifying');
    if (classification.status === 'E') return tr('ai_error');
    if (classification.level == null) return tr('ai_tied');
    return '';
}
